(function(){
  var d=document, root=d.documentElement;
  function $(s,c){return (c||d).querySelector(s)}
  function $$(s,c){return Array.prototype.slice.call((c||d).querySelectorAll(s))}
  function store(k,v){try{if(v===undefined)return localStorage.getItem(k);localStorage.setItem(k,v)}catch(e){return null}}

  /* Header: transparent on top of the home hero */
  var h=$('[data-jd-header]');
  if(h && h.hasAttribute('data-transparent')){
    var onS=function(){h.classList.toggle('is-solid', window.scrollY>40)};
    onS(); window.addEventListener('scroll', onS, {passive:true});
  }

  /* Menu */
  var menu=$('[data-jd-menu]');
  function setMenu(open){
    if(!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open?'false':'true');
    $$('[data-jd-menu-open]').forEach(function(b){b.setAttribute('aria-expanded', open?'true':'false')});
    root.style.overflow = open?'hidden':'';
    if(open){ var c=$('[data-jd-menu-close]'); c && c.focus(); }
  }
  $$('[data-jd-menu-open]').forEach(function(b){b.addEventListener('click',function(){setMenu(true)})});
  $$('[data-jd-menu-close]').forEach(function(b){b.addEventListener('click',function(){setMenu(false)})});
  if(menu) $$('a',menu).forEach(function(a){a.addEventListener('click',function(){setMenu(false)})});

  /* Signup popup */
  var pop=$('[data-jd-pop]');
  function setPop(on){ if(!pop) return; pop.classList.toggle('is-on', on); pop.setAttribute('aria-hidden', on?'false':'true'); if(on){var i=$('input[type=email]',pop); i&&i.focus();} }
  $$('[data-jd-signup]').forEach(function(b){b.addEventListener('click',function(e){e.preventDefault();setMenu(false);setPop(true)})});
  if(pop){
    $$('[data-jd-pop-close]',pop).forEach(function(b){b.addEventListener('click',function(){setPop(false);store('jd_pop','1')})});
    pop.addEventListener('click',function(e){ if(e.target===pop){setPop(false);store('jd_pop','1')} });
    if(pop.hasAttribute('data-posted')) setPop(true);
    else if(!store('jd_pop') && !window.Shopify?.designMode){ setTimeout(function(){ setPop(true) }, 7000); }
  }
  d.addEventListener('keydown',function(e){ if(e.key==='Escape'){ setMenu(false); setPop(false); } });

  /* Countdown */
  $$('[data-countdown]').forEach(function(el){
    var t=Date.parse(el.getAttribute('data-countdown'));
    if(isNaN(t)) return;
    var parts=$$('b',el);
    function pad(n){return (n<10?'0':'')+n}
    function tick(){
      var s=Math.max(0,Math.floor((t-Date.now())/1000));
      var v=[Math.floor(s/86400), Math.floor(s%86400/3600), Math.floor(s%3600/60), s%60];
      parts.forEach(function(p,i){ p.textContent=pad(v[i]) });
      if(s===0){ el.classList.add('is-live'); clearInterval(iv); }
    }
    tick(); var iv=setInterval(tick,1000);
  });

  /* Product gallery */
  $$('[data-jd-gal]').forEach(function(g){
    var tr=$('.jd-gal__track',g), slides=$$('.jd-gal__s',g), dots=$$('.jd-gal__d button',g), num=$('[data-jd-gal-n]',g);
    function idx(){ return Math.round(tr.scrollLeft/tr.clientWidth) }
    function go(i){ i=(i+slides.length)%slides.length; tr.scrollTo({left:i*tr.clientWidth, behavior:'smooth'}) }
    function upd(){ var i=idx(); dots.forEach(function(b,j){b.setAttribute('aria-current', j===i?'true':'false')}); if(num) num.textContent=(i+1)+' / '+slides.length; }
    tr.addEventListener('scroll', function(){ window.requestAnimationFrame(upd) }, {passive:true});
    var p=$('.jd-gal__a--p',g), n=$('.jd-gal__a--n',g);
    p && p.addEventListener('click',function(){go(idx()-1)});
    n && n.addEventListener('click',function(){go(idx()+1)});
    dots.forEach(function(b,j){ b.addEventListener('click',function(){go(j)}) });
    upd();
  });

  /* Quantity */
  $$('[data-jd-qty]').forEach(function(q){
    var i=$('input',q), max=parseInt(q.getAttribute('data-max')||'99',10);
    $$('button',q).forEach(function(b){ b.addEventListener('click',function(){
      var v=parseInt(i.value||'1',10)+(b.getAttribute('data-d')==='+'?1:-1);
      i.value=Math.min(max,Math.max(1,v));
    }) });
  });

  /* Toast */
  var toast=$('[data-jd-toast]'), tt;
  function showToast(){ if(!toast) return; toast.classList.add('is-on'); clearTimeout(tt); tt=setTimeout(function(){toast.classList.remove('is-on')},4500); }
  function setCount(n){ $$('[data-bag-count]').forEach(function(e){ e.textContent=n }) }

  /* Add to bag via AJAX */
  $$('form[data-jd-atc]').forEach(function(f){
    f.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=$('[type=submit]',f), msg=$('.jd-msg',f), label=btn.innerHTML;
      btn.disabled=true; btn.innerHTML='<span>Agregando…</span>'; if(msg){msg.textContent='';msg.classList.remove('is-err')}
      fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(f)})
        .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j }) })
        .then(function(){ return fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart.js').then(function(r){return r.json()}) })
        .then(function(c){ setCount(c.item_count); showToast(); })
        .catch(function(err){ if(msg){ msg.textContent=(err&&(err.description||err.message))||'No se pudo agregar. Intenta de nuevo.'; msg.classList.add('is-err'); } })
        .finally(function(){ btn.disabled=false; btn.innerHTML=label; });
    });
  });

  /* Cart page quantity buttons submit the form */
  $$('[data-jd-cart-qty]').forEach(function(q){
    var i=$('input',q), max=parseInt(q.getAttribute('data-max')||'99',10);
    $$('button',q).forEach(function(b){ b.addEventListener('click',function(){
      var v=parseInt(i.value||'1',10)+(b.getAttribute('data-d')==='+'?1:-1);
      i.value=Math.min(max,Math.max(0,v)); q.closest('form').submit();
    }) });
  });
})();
